import React from "react";
import { useMediaQuery } from "react-responsive";

export function TwoSection({
  firstSection,
  firstLabel,
  secondLabel,
  secondSection,
}) {
  const isMobile = useMediaQuery({
    query: "(max-width: 800px)",
  });

  return (
    <div
      style={{
        display: isMobile ? "block" : "flex",
        alignItems: "center",
        marginTop: "10px",
        marginBottom: "10px",
        gap: "20px",
      }}
    >
      <div>
        <strong>{firstLabel}</strong>
        <br />
        {firstSection}
      </div>

      <div>
        <strong>{secondLabel}</strong>
        <br />
        {secondSection}
      </div>
    </div>
  );
}
